/*
    This file is part of Privateer.

    Privateer is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Privateer is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Privateer.  If not, see <http://www.gnu.org/licenses/>.
*/
import { lang } from './lang.js';

lang.en = {
        // General strings
        QuestionY: "y",
        QuestionN: "n", 
        Continue: "Press any key to continue!",

        // Player related strings
        PlayerRank1_SEAMAN: "seaman",
        PlayerRank1_CAPTAIN: "captain",
        PlayerRank1_LEFTENANTCOMMANDER: "leftenantcommander",
        PlayerRank1_COMMANDER: "commander",
        PlayerRank1_ADMIRAL: "admiral",
        PlayerRank2_CITISEN: "Citisen",
        PlayerRank2_BARON: "BARON",
        PlayerRank2_VISCOUNT: "VISCOUNT",
        PlayerRank2_COUNT: "COUNT",
        PlayerRank2_ROYAL_HEIR: "ROYAL HEIR",
        
        // WELCOME screen strings (aligned with KAPER.BAS intro)
        Welcome1: "Kaptajn Kaper i Kattegat",
        Welcome2: "by P.O.Frederiksen",
        Welcome3: "Version 1 Release 4",
        Welcome4: "",
        Welcome5: "",
        Welcome6: "",
        Welcome7: "",
        Welcome8: "Press any key to continue",
        Welcome9: "E = English language",
        Welcome10: "C = Clear record",
        SoundIntro1: "You can always toggle sound",
        SoundIntro2: "with F2!",
        SoundIntro3: "What do you choose now?:",
        SoundIntro4: "0: Silence",
        SoundIntro5: "1: Sound effects",
        SoundIntro6: "Current value:",
        SoundIntro7: "Enter new value:",
        PlayerName1: "Your ship looks like this:",
        PlayerName2: "What is your name",
        PlayerName3: "You can quit the game by pressing 'escape'!",
        PlayerName4: "Remember: F1=Help, F2=Sound on/off, Esc=Quit",
        
        // MAP screen strings
        Map1: "Point: {0} ",
        Map2: " Goal: {0} in {1} moves",
        Map3: "F1:Help",
        Map4: "F2:Sound",
        Map5: "Esc:Quit",
        Map6: "Move: {0}",
        Map7: "Taels: {0}",
        Map8: "Grain: {0}",
        Map9: "Men: {0}",
        Map10: "Cannons: {0}",
        Map11: "Rep: {0}",
        CityName1: "Grenaa",
        CityName2: "Ebeltoft",
        CityName3: "Moelle",
        CityName4: "Elsinore",
        CityName5: "Hundested",
        CityName6: "Kalundborg",
        CityName7: "Copenhagen",
        
        // PROMOTE screen strings
        Promote1: "Congratulations!!!!",
        Promote2: "You have just received",
        Promote3: "your promotiom by bottlemail.",
        Promote4: "Comtessa Grevious is waiting with ardour!",
        Promote5: "Let us see you meet the next",
        Promote6: "objective {0} {1}!",
        Promote7: "You done it all!!.",
        Promote8: "You get half of the kindom as well.",

        // MIST screen strings
        Mist1: "Lookout reports:",
        Mist2: "Ahoy!",
        Mist3: "There's a strange mist about 2 miles",
        Mist4: "to starboard,",
        Mist5: "There seems to be",
        Mist6: "something inside it.",
        Mist7: "Well {0} {1},",
        Mist8: "time to choose:",
        Mist9: "Will you investigate (y/n)?",
        MistType11: "Out of the prineval mist",
        MistType12: "a terryfying ship appears!",
        MistType21: "Well blow me down!",
        MistType22: "It was nought after all.",
        MistType31: "You find an island",
        MistType32: "with {0} sacks of grain!",
        MistType41: "You find an island",
        MistType42: "with {0} jewels!",
        MistType51: "You find an island",
        MistType52: "with a treasurechest,",
        MistType53: "containing {0} taels!",
        MistType61: "You find an island",
        MistType62: "with an abandoned cannon,",
        MistType63: "which you take aboard your ship!",
        MistType71: "You find an island",
        MistType72: "with a shipwrecked crew.",
        MistType73: "They agree to join your crew!",
        MistType81: "You find an island",
        MistType82: "with a shipwrecked plague victim!",
        MistType83: "Your crew get the plague and",
        MistType84: "one third of them perish!",
        MistType85: "The rest are not impressed with",
        MistType86: "your leadership!",

        // ATTACK screen strings
        Attack1: "The lookout shouts:",
        Attack2: "Ship ahoy!",
        Attack3: "{0} in sight",
        Attack4: "Well {0} {1},",
        Attack5: "time to choose:",
        Attack6: "Will you attack (a) or flee (f)?",
        AttackY: "a",
        AttackN: "f", 
        EnemyName1: "English merchant ship",
        EnemyName2: "English troopcarrier",
        EnemyName3: "English gunboat",
        EnemyName4: "English frigate",
        EnemyName5: "English brig",
        EnemyName6: "English schooner",
        EnemyName7: "English man o'war",
        EnemyName8: "Pirate ship",
        Attacking1: "Will you board her (b) or",
        Attacking2: "will you shoot (s) it out?", 
        AttackTypeB: "b",
        AttackTypeS: "s", 
        AttackSurrender1: "They surrender!!",
        AttackSurrender2: "There is {0} taels aboard her.",
        AttackSurrender3: "There are {0} survivors.",
        AttackSurrender4: "The deck is awash with bodies.",
        AttackSurrender5: "There is {0} sacks of grain aboard.",
        AttackSurrender6: "You take them!",
        AttackSurrender7: "This ship needs a prizecrew of",
        AttackSurrender8: "{0} men!",
        AttackSurrender9: "You have {0} men.",
        AttackSurrender10: "Do you sink it, (s)",
        AttackSurrender11: "or do you take it as prize (p) ?",
        AttackSurrender12: "OK, They are en route for Copenhagen.",
        AttackSurrenderP: "p",
        AttackSurrenderS: "s",
        AttackSunk1: "She disappeared without a trace!!",
        AttackSunk2: "You throw {0} men to the sharks!",
        
        // SHOOT screen strings
        Shooting1: "Enemy",
        Shooting2: "Own",
        Shooting3: "Aim",
        Shooting4: "Hits",
        Shooting5: "F=fire. 0=withdraw",
        Shooting6: "Dist: {0}",
        Shooting7: "Wind",
        Shooting8: "Guns",
        Shooting9: "Men",
        Shooting10: "Rep",
        Shooting11: "Press any key.",
        ShootTypeF: "f",
        ShootTypeW: "0",
        
        // BOARD screen strings
        Boarding1: "Battle rages aboard",
        Boarding2: "{0} !",
        Boarding3: "The enemy has  {0}  dead,",
        Boarding4: "but he has  {0}  remaining.",
        Boarding5: "You have lost  {0}  of your brave crew.",
        Boarding6: "Will you fight on (f)",
        Boarding7: "or withdraw to your ship (w)?",
        BoardingEnemyName1: "the English",
        BoardingEnemyName2: "the pirate ship",
        BoardTypeF: "f",
        BoardTypeW: "w",
        
        // HARBOR screen strings
        Harbor1: "You are entering the port of {0}.",
        Harbor2: "Steer clear of other ships anchored",
        Harbor3: "outside the harbour.",
        Harbor4: "Use the arrow buttons to",
        Harbor5: "move left and right.",
        Harbor6: "If you bump into one of",
        Harbor7: "the other ships, your ship will",
        Harbor8: "suffer damage, but if you",
        Harbor9: "miss the harbour entrance,",
        Harbor10: "you will not survive!",
        Harbor11: "Watch out for gusts of wind from the",
        Harbor12: "left!",
        Harbor13: "right!",
        Prize1: "Great!",
        Prize2: "Here in Copenhagen your {0}",
        Prize3: "stout men await you.",
        Prize4: "They have {0} taels",
        Prize5: "in prizemoney for you!",
        Dead1: "Your ship is done for",
        Dead2: "and so are you!",
        
        // CITY screen strings
        City1:"Welcome to {0}",
        City2:"What do you want?   {0}",
        City3:"1:Hire more men ( {0} taels each)",
        City4:"2:Repair the ship ( {0} taels per point)",
        City5:"3:Buy Cannon ( {0} taels each)",
        City6:"4:Buy grain ( {0} taels each)",
        City7:"5:Sell something",
        City8:"6:Leave the port.",
        CityBuy1:"How many? {0}",
        CityBuy2:"You can't afford that!",
        CityBuy3:"That is too much!",
        CitySell1:"Grain(g), Cannon(c) or  Jewels(j) ?",
        CitySell2:"How many cannon will you sell? {0}",
        CitySell3:"How many sacks will you sell? {0}",
        CitySell4:"How many jewels will you sell? {0}",
        CitySell5: "You haven`t that many!",
        CitySellG: "g",
        CitySellC: "c",
        CitySellJ: "j",

        // GAME_LOST screen strings
        EndGame1: "Sorry!",
        EndGame2: "Your ship went down with all hands!",
        EndGame3: "You got {0} point and had {1} taels!",
        EndGame4: "You ended with {0} men",
        EndGame5: "and {0} repair points",
        CauseOfDeath_TOO_MANY_MONEY: "The veight of all your money",
        CauseOfDeath_TOO_MANY_MEN: "The veight of all your men",
        CauseOfDeath_TOO_MANY_CANNONS: "The veight of all your cannon",
        CauseOfDeath_TOO_MANY_GRAIN: "The veight of all your grain",
        CauseOfDeath: "sinks the ship!",
        CauseOfDeath_TOO_MANY_MOVES1: "We are sad to announce, that the comtessa",
        CauseOfDeath_TOO_MANY_MOVES2: "Grevious Faulty of Manure Manor",
        CauseOfDeath_TOO_MANY_MOVES3: "today is married to",
        CauseOfDeath_TOO_MANY_MOVES4: "the ornerous Sir Dallybound of Wicketfence!",
        CauseOfDeath_TOO_MANY_MOVES5: "In despair you take the long swim!",
        
        // HIGHSCORE screen strings
        HighScore1: "You got  {0}",
        HighScore2: "Press any key to start again.",
        RecordLabel: "Rec.",
        RecordHolderLabel: "Holder",

            // HELP menues
        HelpMain1: "Which subject do you want to study?:",
        HelpMain2: " 1: General description",
        HelpMain3: " 2: Navigation",
        HelpMain4: " 3: Ports",
        HelpMain5: " 4: Fighting with cannon",
        HelpMain6: " 5: Fight by boarding",
        HelpMain7: " 6: Crew wellfare",
        HelpMain8: " 7: Prizes, prizemoney og pricecrew",
        HelpMain9: " 8: Trade",
        HelpMain10: " 9: Fog, plague, and treasures",
        HelpMain11: " 0: Programinformation",
        HelpMain13: "  Choose 0-9",
        HelpMain14: " or press a letter,",
        HelpMain15: " if you want to return to the game!",
        HelpMenu1_1_1: "Now imagine yourself at the time",
        HelpMenu1_1_2: "just after the battle of Copenhagen.",
        HelpMenu1_1_4: "The foul British have stolen most of",
        HelpMenu1_1_5: "our ships; just a pitiful few ships -",
        HelpMenu1_1_6: "yours among them - remain.",
        HelpMenu1_1_8: "The British sail as they please",
        HelpMenu1_1_9: "in our sounds and straits.",
        HelpMenu1_1_11: "The King has given you a letter",
        HelpMenu1_1_12: "of marque, empowering you to capture",
        HelpMenu1_1_13: "all the British ships you find.",
        HelpMenu1_1_15: "You are given a large sum as",
        HelpMenu1_1_16: "prizemoney for each ship you take",
        HelpMenu1_1_17: "and deliver it to Copenhagen.",
        HelpMenu1_1_19: "Where you have won a battle, the",
        HelpMenu1_1_20: "Brits no longer dare to venture!",
        HelpMenu1_1_22: "That goes for pirates to!",
        HelpMenu1_2_1: "You will get points for defeating",
        HelpMenu1_2_2: "the British, and if you get enough",
        HelpMenu1_2_3: "the King will give you a title.",
        HelpMenu1_2_5: "As a nobleman, you may fullfill your",
        HelpMenu1_2_6: "fondest dream:",
        HelpMenu1_2_7: "You can marry your secret fiance,",
        HelpMenu1_2_8: "Comtessa Greivious Faulty",
        HelpMenu1_2_9: "from Manure Manor.",
        HelpMenu1_2_11: "But you must hurry!!",
        HelpMenu1_2_13: "Sir Dallybound of Wicketfence has",
        HelpMenu1_2_14: "an eye for the Comtessa, and if you",
        HelpMenu1_2_15: "are not titled fast enough, then",
        HelpMenu1_2_16: "Count Faulty will give his daughters",
        HelpMenu1_2_17: "hand in marriage to your rich rival!",
        HelpMenu1_2_19: "Therefore: Be brave and swift",
        HelpMenu1_2_20: "and keep you powder dry!",
        HelpMenu2_1_1: "You can see yourself on the map of",
        HelpMenu2_1_2: "the Danish inland sea. You are a small",
        HelpMenu2_1_3: "ship, merrily sailing along.",
        HelpMenu2_1_5: "You can move in 8 directions by using",
        HelpMenu2_1_6: "keys 1-4 and 6-8 (the arrowkeys).",
        HelpMenu2_1_8: "You cannot sail outside the map, and",
        HelpMenu2_1_9: "you cannot sail on land, but",
        HelpMenu2_1_10: "it may look as if you cross",
        HelpMenu2_1_11: "peninsulas once in a while.",
        HelpMenu3_1_1: "There are 7 ports on the map.",
        HelpMenu3_1_3: "When you enter a square with a port",
        HelpMenu3_1_4: "you will have to dock there.",
        HelpMenu3_1_6: "You must steer past all the ships which",
        HelpMenu3_1_7: "are anchored uotside the harbour.",
        HelpMenu3_1_9: "Use key 4 and 6 for  steering.",
        HelpMenu3_1_11: "If you hit one of the other ships",
        HelpMenu3_1_12: "your own ship will suffer more or",
        HelpMenu3_1_13: "less damage, but if you miss the",
        HelpMenu3_1_14: "entrance and hit the harbour wall,",
        HelpMenu3_1_15: "your ship is lost",
        HelpMenu3_1_16: "and the game is over!",
        HelpMenu3_1_18: "Look out for sudden gusts of wind. They",
        HelpMenu3_1_19: "may blow you off course.",
        HelpMenu4_1_1: "When you meet an enemy you",
        HelpMenu4_1_2: " can either fight or flee.",
        HelpMenu4_1_3: "The more you flee, the lower the morale",
        HelpMenu4_1_4: "of your crew wil become, and the",
        HelpMenu4_1_5: "less bravely will they fight!",
        HelpMenu4_1_7: "If you choose to fight with cannon,",
        HelpMenu4_1_8: "you will be shown a view of the enemy",
        HelpMenu4_1_9: "ship to use for laying the guns.",
        HelpMenu4_1_11: "The aim, which is shown as a cross,",
        HelpMenu4_1_12: "is moved by the arrowkeys",
        HelpMenu4_1_14: "Have a look at the screen.",
        HelpMenu4_3_1: "In the upper left you can see how your",
        HelpMenu4_3_2: "own shots hit around the enemy, and how",
        HelpMenu4_3_3: "his shots fall around you.",
        HelpMenu4_3_5: "That is only true at the start.",
        HelpMenu4_3_6: "Later on, you will have to make do with",
        HelpMenu4_3_7: "the splash on the top right.",
        HelpMenu4_3_9: "It appears only briefly and you can",
        HelpMenu4_3_10: "not even see it if it is hidden behind",
        HelpMenu4_3_11: "the enemy ship.",
        HelpMenu4_3_13: "Have another look at the layout.",
        HelpMenu4_5_1: "At the bottom left you is the distance,",
        HelpMenu4_5_2: "direction and speed of the wind, all of",
        HelpMenu4_5_3: "which are important for",
        HelpMenu4_5_4: "how you lay you cannon.",
        HelpMenu4_5_6: "If you don't like the distance, you may",
        HelpMenu4_5_7: "withdraw (0) and attack again from",
        HelpMenu4_5_8: " a different angle and distance.",
        HelpMenu4_5_10: "You may withdraw for other reasons",
        HelpMenu4_5_11: "for instanse because you are loosing,",
        HelpMenu4_5_12: "or because you prefer to board.",
        HelpMenu4_5_14: "Watch the screen again.",
        HelpMenu4_7_1: "The table at the bottom shows your",
        HelpMenu4_7_2: "strength compared to your opponents.",
        HelpMenu4_7_4: "The more cannon you have, the more",
        HelpMenu4_7_5: "damage will he suffer when you hit.",
        HelpMenu4_7_6: "And vice versa of course!",
        HelpMenu4_7_8: "You can follow the fight on the table.",
        HelpMenu4_7_10: "If you get below 20 repair points,",
        HelpMenu4_7_11: "your ship will sink.",
        HelpMenu4_7_13: "If you have less than 10 men left,",
        HelpMenu4_7_14: "you loose control of the ship.",
        HelpMenu4_7_15: "That will cause you to sink, as well!",
        HelpMenu4_7_17: "Watch the screen one last time.",
        HelpMenu4_9_1: " ", // Hack to make empty screen
        HelpMenu5_1_1: "If you choose to board, a number",
        HelpMenu5_1_2: "of the enemy and your crew will die!",
        HelpMenu5_1_4: "How many depend much on the morale of",
        HelpMenu5_1_5: "your men and the balance of strength.",
        HelpMenu5_1_7: "If but a few of the enemy remain they",
        HelpMenu5_1_8: "will surrender, else you will have to",
        HelpMenu5_1_9: "either continue the fight or",
        HelpMenu5_1_10: "withdraw to your ship to either",
        HelpMenu5_1_11: "flee or try to shoot it out.",
        HelpMenu5_1_13: "An advantage of boarding is that the",
        HelpMenu5_1_14: "ship never sinks - that may happen when",
        HelpMenu5_1_15: "you use cannon - so you always get your",
        HelpMenu5_1_16: "hands on their money when boarding.",
        HelpMenu5_1_18: "When they have surrendered you can",
        HelpMenu5_1_19: "sink the ship (the survivers will join",
        HelpMenu5_1_20: "your crew) or you can size the ship as",
        HelpMenu5_1_21: "a prize.",
        HelpMenu5_1_23: "More information on prizes under 7.",
        HelpMenu6_1_1: "Your men may get killed by the enemy.",
        HelpMenu6_1_3: "That can happen when duelling on",
        HelpMenu6_1_4: "cannon or when boarding.",
        HelpMenu6_1_6: "The crew eats a certain amount of grain",
        HelpMenu6_1_7: "pr. move, and if you run out of grain",
        HelpMenu6_1_8: "the men will slowly starve to death.",
        HelpMenu6_1_10: "That makes it high time to buy",
        HelpMenu6_1_11: "some more grain (see under 8).",
        HelpMenu6_1_13: "The crew may die from the plague.",
        HelpMenu6_1_14: "Read more of that under 9.",
        HelpMenu6_1_16: "Morale and fighting ability",
        HelpMenu6_1_17: "of the crew goes down each time you",
        HelpMenu6_1_18: "flee or withdraw, but increases",
        HelpMenu6_1_19: "with each victory.",
        HelpMenu7_1_1: "When you take a prize, you have",
        HelpMenu7_1_2: "to deliver it safely to Copenhagen.",
        HelpMenu7_1_3: "You do that by providing a",
        HelpMenu7_1_4: "prizecrew for the ship. It has to get",
        HelpMenu7_1_5: "the ship and the prisoners safely",
        HelpMenu7_1_6: "to the capital.",
        HelpMenu7_1_8: "The size of the prizecrew depend on",
        HelpMenu7_1_9: "athe size of the ship and on how many",
        HelpMenu7_1_10: "prisoners, they have to gard.",
        HelpMenu7_1_11: "You will be told, how many you need.",
        HelpMenu7_1_13: "The prize does not always reach",
        HelpMenu7_1_14: "Copenhagen. Ships sometime dissapear,",
        HelpMenu7_1_15: "and neither ship or hide or hair",
        HelpMenu7_1_16: "of the crew is ever seen again.",
        HelpMenu7_1_17: "Usually it is OK, and on your next",
        HelpMenu7_1_18: "visit ti Copenhagen, your men will be",
        HelpMenu7_1_19: "waiting for you with a nice sum",
        HelpMenu7_1_20: "in prizemoney.",
        HelpMenu8_1_1: "In the ports you can trade.",
        HelpMenu8_1_3: "You can have the ship repaired",
        HelpMenu8_1_4: " - ie. increase your repair points -",
        HelpMenu8_1_5: "or you can hire more men.",
        HelpMenu8_1_7: "You may buy grain and cannon.",
        HelpMenu8_1_8: "You may sell grain, cannon, and jewels.",
        HelpMenu8_1_10: "Prices are in Taels, and allthough",
        HelpMenu8_1_11: "they vary with time and place, there",
        HelpMenu8_1_12: "is no negociating about the price.",
        HelpMenu8_1_13: "You may sell grain in order to",
        HelpMenu8_1_14: "buy cannon or vice verca,",
        HelpMenu8_1_15: "but you can not sell your crew!",
        HelpMenu8_1_17: "Jewels are rare and cannot be bought",
        HelpMenu8_1_18: "They may be found in secret places.",
        HelpMenu8_2_1: "Don't buy to much, for your",
        HelpMenu8_2_2: "ship will not float with more than",
        HelpMenu8_2_3: "150 cannon and 500 men.",
        HelpMenu8_2_5: "Taels are heavy too,",
        HelpMenu8_2_6: "so don't try to sail with more than",
        HelpMenu8_2_7: "30,000 Taels if you value your life.",
        HelpMenu8_2_9: "Neither is it wise to carry",
        HelpMenu8_2_10: "more than 700 sacks of grain.",
        HelpMenu9_1_1: "From time to time you may se a strange",
        HelpMenu9_1_2: "mist which youmay investigate or",
        HelpMenu9_1_3: "choose to avoid.",
        HelpMenu9_1_5: "What it hides may be good or not good",
        HelpMenu9_1_6: "AT ALL!!!!!!!",
        HelpMenu9_1_8: "Jewels and plague are among",
        HelpMenu9_1_9: "the possibilities.",
        HelpMenu0_1_1: "This program is in the public domaine,",
        HelpMenu0_1_2: "So you are free to copy it.",
        HelpMenu0_1_3: "Remember, that DOS is still a licensed",
        HelpMenu0_1_4: "program and should be treated like one!",
        HelpMenu0_1_6: "If you feel, that you would like to pay",
        HelpMenu0_1_7: "for the program, you are wellcome to",
        HelpMenu0_1_8: "send eg. 5 pounds to:",
        HelpMenu0_1_10: "Peter O. Frederiksen",
        HelpMenu0_1_11: "Astrupvej 30",
        HelpMenu0_1_12: "DK8550 Ryomgaard",
        HelpMenu0_1_13: "Denmark",
        HelpMenu0_1_14: "", // Hack to make 2 empty lines in a rowk
        HelpMenu0_1_16: "You may also send me the money by using",
        HelpMenu0_1_17: "my postal account (giro) in Denmark.",
        HelpMenu0_1_18: "It has number 5202531.",
        HelpMenu0_1_20: "If you want the source code,",
        HelpMenu0_1_21: "just send me 50 pounds",
        HelpMenu0_1_22: "and I will send it to you."
    };
export default lang.en;
